<template>
  <div class="grid crud-demo">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template #start>
            <div class="my-2">
              <Button
                label="Novo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="openNew"
              />
            </div>
          </template>

          <template #end>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="processos"
          :selection.sync="selectedProcessos"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters.sync="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} processos"
          class="p-datatable-customers"
          responsiveLayout="scroll"
        >
          <template #header>
            <div
              class="table-header flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0">Processos seletivos</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Filtrar..."
                />
              </span>
            </div>
          </template>
          <Column field="id" style="width: 1px" header="ID" :sortable="true" />
          <Column field="nome" header="Processo" :sortable="true" />
          <Column field="descricao" header="Descrição" :sortable="true" />
          <Column
            field="tipoSelecao.descricao"
            header="Tipo de Processo"
            :sortable="true"
          />
          <Column
            field="datHoraInicioInscricao"
            header="Início inscrição"
            :sortable="true"
          >
            <template #body="slotProps">
              <span>{{
                formatarDataBR(slotProps.data.datHoraInicioInscricao).substring(
                  0,
                  10
                )
              }}</span>
            </template>
          </Column>

          <Column
            field="datHoraFimInscricao"
            header="Fim inscrição"
            :sortable="true"
          >
            <template #body="slotProps">
              <span>{{
                formatarDataBR(slotProps.data.datHoraFimInscricao).substring(
                  0,
                  10
                )
              }}</span>
            </template>
          </Column>

          <Column
            field="estadoSelecao.descricao"
            header="Estado"
            :sortable="true"
          >
            <template #body="slotProps">
              <span
                :class="
                  'processo-badge status-' +
                    (slotProps.data.estadoSelecao.cod == '4'
                      ? 'finalizado'
                      : 'em-andamento')
                "
                >{{ slotProps.data.estadoSelecao.descricao }}</span
              >
            </template>
          </Column>

          <Column>
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.finalizado"
                icon="pi pi-file"
                class="p-button-rounded p-button-secondary mr-2"
                @click="viewProcesso(slotProps.data, false)"
              />
              <Button
                v-if="!slotProps.data.finalizado"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editProcesso(slotProps.data)"
              />
              <Button
                v-if="!slotProps.data.finalizado"
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDeleteProcesso(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog :visible.sync="processoDialog" :containerStyle="{ width: '70vw' }" header="Detalhes do Processo" :modal="true">

          <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">
            {{ msg.content }}
          </Message>

          <ValidationObserver v-slot="{ handleSubmit }">
            <form
              id="formSalvarProcesso"
              @submit.prevent="handleSubmit(saveProcesso)"
            >
              <div class="card" :class="{ 'p-disabled': !flagEditarProcesso }">
                <div class="formgrid grid ">
                  <div class="field col-12 md:col-6">
                    <label for="nome" class="font-bold required"
                      >Nome do processo</label
                    >
                    <ValidationProvider
                      name="Nome do processo"
                      rules="required|min:10"
                      v-slot="{ errors }"
                      mode="lazy"
                    >
                      <InputText
                        class="surface-overlay p-2  appearance-none outline-none focus:border-primary w-full"
                        id="nome"
                        v-model="processo.nome"
                        :class="{ 'field-invalid': errors[0] }"
                      />
                      <InlineMessage v-if="errors[0]">{{
                        errors[0]
                      }}</InlineMessage>
                    </ValidationProvider>
                  </div>

                  <div class="field col-12 md:col-3">
                    <label for="Área" class="font-bold  required"
                      >Estado do processo</label
                    >
                    <ValidationProvider
                      name="Estado da seleção"
                      rules="required"
                      v-slot="{ errors }"
                      mode="lazy"
                    >
                      <Dropdown
                        class="surface-overlay appearance-none outline-none focus:border-primary w-full"
                        id="area"
                        v-model="processo.estadoSelecao"
                        :options="dropdownEstadosSelecao"
                        optionLabel="descricao"
                        placeholder="Selecione um estado ..."
                        :class="{ 'field-invalid': errors[0] }"
                        style="width: 200px"
                        :disabled="
                          processo.estadoSelecao.cod == 3 ||
                          processo.estadoSelecao.cod == 4
                            ? false
                            : true
                        "
                      />
                      <InlineMessage v-if="errors[0]">{{
                        errors[0]
                      }}</InlineMessage>
                    </ValidationProvider>
                  </div>
                  <div class="field col-12 md:col-3">
                    <label for="coeficienteMinimo" class="font-bold required" >Coeficiente mínimo de rendimento escolar</label>
                    <ValidationProvider name="Coeficiente mínimo de rendimento escolar"
                      rules="required|min_value:1|max_value:10"  v-slot="{ errors }"
                      mode="lazy" class="surface-overlay appearance-none outline-none focus:border-primary w-full">
                      <InputNumber
                        id="coeficienteMinimo" v-model="processo.coeficienteMinimo" mode="decimal"
                        decimalSeparator="," :minFractionDigits="2" locale="de-DE"
                        :class="{ 'field-invalid': errors[0] }"
                        class="surface-overlay appearance-none outline-none focus:border-primary w-full"/>
                      <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                    </ValidationProvider>
                  </div>

                  <div class="field col-12 md:col-6">
                    <label for="descricao" class="font-bold required mr-4">Descrição do processo</label>
                    <ValidationProvider name="Descrição do processo"
                      rules="required|min:10" v-slot="{ errors }" mode="lazy">
                      <InputText
                        class="surface-overlay appearance-none outline-none focus:border-primary w-full"
                        id="descricao"
                        v-model="processo.descricao"
                        :class="{ 'field-invalid': errors[0] }"/>
                      <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                    </ValidationProvider>
                  </div>

                  <div class="field col-12 md:col-3 ">
                    <label
                      for="datHoraInicioInscricao"
                      class="font-bold required "
                    >
                      Data de início de inscrição
                    </label>
                    <ValidationProvider
                      name="Data de início de inscrição"
                      rules="required"
                      v-slot="{ errors }"
                      class="surface-overlay appearance-none outline-none focus:border-primary"
                    >
                      <Calendar
                        :class="{ 'field-invalid': errors[0] }"
                        :showIcon="true"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                        id="datHoraInicioInscricao"
                        class=" surface-overlay appearance-none outline-none focus:border-primary w-full"
                        v-model="processo.datHoraInicioInscricao"
                        showWeekHeader="true"
                        :showTime="false"
                      />
                      <InlineMessage v-if="errors[0]">{{
                        errors[0]
                      }}</InlineMessage>
                    </ValidationProvider>
                  </div>

                  <div class="field col-12 md:col-3">
                    <label
                      for="datHoraFimInscricao"
                      class="font-bold required "
                      required="true"
                    >
                      Data de fim de inscrição
                    </label>
                    <ValidationProvider
                      name="Data de fim de inscrição"
                      rules="required"
                      v-slot="{ errors }"
                      class="surface-overlay appearance-none outline-none focus:border-primary"
                    >
                      <Calendar
                        :class="{ 'field-invalid': errors[0] }"
                        :showIcon="true"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                        id="datHoraFimInscricao"
                        class=" surface-overlay appearance-none outline-none focus:border-primary w-full"
                        v-model="processo.datHoraFimInscricao"
                        showWeekHeader="true"
                        :showTime="false"
                      />
                      <InlineMessage v-if="errors[0]">{{
                        errors[0]
                      }}</InlineMessage>
                    </ValidationProvider>
                  </div>
                  <div class="field mt-2 col-12 md:col-3">
                    <span class="">
                      <label
                        class="font-bold required "
                        required="true"
                        for="area"
                      >
                        Turno da prova
                      </label>
                      <ValidationProvider
                        name="Turno da prova"
                        rules="required"
                        v-slot="{ errors }"
                        mode="lazy"
                      >
                        <Dropdown
                          class=" required surface-overlay appearance-none outline-none focus:border-primary w-full"
                          id="turno"
                          v-model="processo.turnoProva"
                          :options="dropdownTurnos"
                          optionLabel="name"
                          autofocus
                          :class="{ 'field-invalid': errors[0] }"
                        />
                        <InlineMessage v-if="errors[0]">{{
                          errors[0]
                        }}</InlineMessage>
                      </ValidationProvider>
                    </span>
                  </div>
                  <div class="field mt-2 col-12 md:col-3">
                    <span class="">
                      <label
                        class="font-bold required "
                        required="true"
                        for="tipoSelecao"
                        >Tipo de processo seletivo</label
                      >
                      <ValidationProvider
                        name="Tipo de de processo seletivo"
                        rules="required"
                        v-slot="{ errors }"
                        mode="lazy"
                      >
                        <Dropdown
                          class=" required surface-overlay appearance-none outline-none focus:border-primary w-full"
                          id="tipoSelecao"
                          v-model="processo.tipoSelecao"
                          :options="dropdownTiposSelecao"
                          optionLabel="descricao"
                          autofocus
                          :class="{ 'field-invalid': errors[0] }"
                        />
                        <InlineMessage v-if="errors[0]">{{
                          errors[0]
                        }}</InlineMessage>
                      </ValidationProvider>
                    </span>
                  </div>
                  <div class="field  mt-2 col-12 md:col-2">
                    <span>
                      <label
                        class="font-bold required "
                        required="true"
                        for="dataHoraInicioProva"
                      >
                        Data da prova
                      </label>
                      <ValidationProvider
                        name="Data da prova"
                        v-slot="{ errors }"
                        rules="required"
                      >
                        <Calendar
                          :class="{ 'field-invalid': errors[0] }"
                          :showIcon="true"
                          :minDate="minDate"
                          dateFormat="dd/mm/yy"
                          appendTo="body"
                          id="dataProva"
                          class=" surface-overlay appearance-none outline-none focus:border-primary w-full"
                          v-model="processo.dataProva"
                          showWeekHeader="true"

                        />
                        <InlineMessage v-if="errors[0]">{{
                          errors[0]
                        }}</InlineMessage>
                      </ValidationProvider>
                    </span>
                  </div>

                  <div class="field  mt-2 col-12 md:col-2">
                    <span class="">
                      <label class="font-bold required " required="true" for="horaInicioProva">
                        Horário de início da prova
                      </label>
                      <ValidationProvider name="Horário de início da prova" v-slot="{ errors }" rules="required">
                        <Calendar
                          :class="{ 'field-invalid': errors[0] }"
                          :showIcon="true"
                          id="horaInicioProva"
                          class=" surface-overlay appearance-none outline-none focus:border-primary w-full"
                          v-model="processo.horaInicioProva"
                          :timeOnly="true" hourFormat="24"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </span>
                  </div>
                  <div class="field  mt-2 col-12 md:col-2">
                    <span class="">
                      <label class="font-bold required " required="true" for="horaFimProva">
                        Horário de fim da prova
                      </label>
                      <ValidationProvider name="Horário de fim da prova" v-slot="{ errors }" rules="required">
                        <Calendar
                          :class="{ 'field-invalid': errors[0] }"
                          :showIcon="true"
                          id="horaFimProva"
                          class=" surface-overlay appearance-none outline-none focus:border-primary w-full"
                          v-model="processo.horaFimProva"
                          showWeekHeader="true"
                          :timeOnly="true"
                          hourFormat="24"/>
                        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                      </ValidationProvider>
                    </span>
                  </div>

                </div>
              </div>
            </form>
          </ValidationObserver>
          <Panel header="Áreas do processo" :toggleable="true">
            <form class="p-2" id="formAreaProcesso" v-if="flagEditarProcesso">
              <div class="p-fluid formgrid grid ">
                <div class="field col-12 md:col-3">
                  <span class="p-float-label">
                    <Dropdown id="area" class="required"
                      v-model="selecaoEstagioArea.area" :options="dropdownAreas"
                      optionLabel="nome" autofocus/>
                    <label for="area">Selecione uma área</label>
                  </span>
                </div>
                <div class="field col-12 md:col-3">
                  <span class="p-float-label">
                    <InputNumber id="vagas"
                      class="required surface-overlay appearance-none outline-none focus:border-primary"
                      v-model="selecaoEstagioArea.vagas"/>
                    <label class=" surface-overlay appearance-none outline-none focus:border-primary w-full" for="vagas">
                      Vagas ampla concorrência
                    </label>
                  </span>
                </div>
                <div class="field col-12 md:col-3">
                  <span class="p-float-label">
                    <InputNumber id="vagasConvenio" class="required" v-model="selecaoEstagioArea.vagasConvenio"/>
                    <label for="vagasConvenio">Vagas Convênio </label>
                  </span>
                </div>
                <div class="field col-12 md:col-3">
                  <span class="p-float-label">
                    <InputNumber id="reservas" class="required" v-model="selecaoEstagioArea.reservadas"/>
                    <label for="reservas">Vagas pessoa com deficiência </label>
                  </span>
                </div>

                <div class=" w-12  field col-12 md:col-6  flex justify-content-end flex-wrap card-container green-container ">
                  <Button
                    icon="pi pi-check"
                    class="justify-content-center mr-2"
                    @click="saveAreaProcesso"/>
                  <Button
                    icon="pi pi-times"
                    class="justify-content-center  p-button-danger p-button-outlined mr-2"
                    @click="CancelarAreaProcesso"/>
                </div>
              </div>
            </form>

            <DataTable ref="dt" :value="areasProcesso" dataKey="area.nome"
              :paginator="true"
              :rows="5"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[5, 10, 25]"
              currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} áreas"
              class="p-datatable-sm p-datatable-gridlines p-datatable-striped"
              responsiveLayout="scroll">
              <Column field="nome" header="Área" headerStyle="width: 40%">
                <template #body="slotProps">
                  {{ slotProps.data.area.nome }}
                  <p v-if="slotProps.data.vagas === 0" class="font-bold required mr-4">
                    (Cadastro de Reserva)
                  </p>
                </template>
              </Column>
              <Column header="Total de vagas">
                <template #body="slotProps">
                  {{ slotProps.data.vagas + slotProps.data.reservadas + slotProps.data.vagasConvenio }}
                </template>
              </Column>
              <Column field="vagas" header="Vagas ampla concorrência" :sortable="true"/>
              <Column field="vagasConvenio" header="Vagas Convênio" :sortable="true">
                <template #body="slotProps">
                  {{ slotProps.data.vagasConvenio ? slotProps.data.vagasConvenio : 0 }}
                </template>
              </Column>
              <Column field="reservadas" header="Vagas estudantes com deficiência" :sortable="true" />
              <Column v-if="flagEditarProcesso">
                <template #body="slotProps">
                  <Button
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-success mr-2"
                    @click="editAreaProcesso(slotProps.data)"
                  />
                  <Button
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-warning"
                    @click="confirmDeleteAreaProcesso(slotProps.data)"
                  />
                </template>
              </Column>
            </DataTable>
          </Panel>

          <template #footer>
            <Button
              label="Salvar"
              type="submit"
              form="formSalvarProcesso"
              icon="pi pi-check"
              class="p-button-text"
              v-if="flagEditarProcesso"
            />
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text p-button-danger"
              @click="hideDialog"
            />
          </template>
        </Dialog>

        <Dialog
          :visible.sync="deleteProcessoDialog"
          :style="{ width: '450px' }"
          header="Confirmar exclusão"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <em class="pi pi-exclamation-triangle" style="font-size: 2rem" />
            <span v-if="processo" class="ml-3"
              >Você tem certeza que deseja excluir o processo
              <strong>{{ processo.nome }}</strong
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="Sim"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteProcesso"
            />
            <Button
              label="Não"
              icon="pi pi-times"
              class="p-button-text p-button-danger"
              @click="deleteProcessoDialog = false"
            />
          </template>
        </Dialog>

        <Dialog
          :visible.sync="deleteAreaDialog"
          :style="{ width: '450px' }"
          header="Confirmar exclusão"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <em class="pi pi-exclamation-triangle" style="font-size: 2rem" />
            <span class="ml-3"
              >Você tem certeza que deseja excluir a área do processo
              seletivo?</span
            >
          </div>
          <template #footer>
            <Button
              label="Sim"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteAreaProcesso"
            />
            <Button
              label="Não"
              icon="pi pi-times"
              class="p-button-text p-button-danger"
              @click="deleteAreaDialog = false"
            />
          </template>
        </Dialog>

        <ConfirmDialog></ConfirmDialog>
      </div>
    </div>
  </div>
</template>

<script>
import ProcessoService from "../../service/ProcessoService";
import AreaService from "../../service/AreaService";
import AreaProcessoService from "../../service/AreaProcessoService";
import EstadoSelecaoService from "../../service/EstadoSelecaoService";
import ConfirmDialog from "primevue/confirmdialog";

import { tratamentoDeErros } from "@/tratamentoDeErros";
import { validacaoFormulario } from "@/validacaoFormulario";
import DataService from "../../service/DataService";
import { FilterMatchMode } from "primevue/api";
import moment from "moment";
export default {
  mixins: [tratamentoDeErros, validacaoFormulario],
  components: { ConfirmDialog },
  data() {
    return {
      minDate: null,
      maxDate: null,
      invalidDates: null,
      flagEdit: false,
      flagEditarProcesso: false,

      messages: [],
      blockedPanel: false,
      processos: null,
      selecaoEstagioArea: {},
      selecaoEstagioAreaDel: {},
      selecaoEstagioAreaAnterior: {},
      processoDialog: false,
      deleteProcessoDialog: false,
      deleteAreaDialog: false,
      processo: {estadoSelecao:{cod:0}},

      processoAnterior: {},
      areasProcesso: [],
      selectedProcessos: null,
      filters: {},
      submitted: false,
      statuses: [
        { label: "EM ANDAMENTO", value: "Em andamento" },
        { label: "FINALIZADO", value: "Finalizado" },
      ],
      area: {},
      submittedArea: false,
      dropdownAreas: [],
      dropdownTurnos: [{ name: "Manhã" }, { name: "Tarde" }],
      dropdownEstadosSelecao: [],
      dropdownTiposSelecao: [],
    };
  },
  processoService: null,
  dataDeserializationService: null,
  estadoSelecaoService: null,
  areaService: null,
  areaProcessoService: null,
  created() {
    this.initFilters();
    this.dataDeserializationService = new DataService();
    this.processoService = new ProcessoService();

    this.areaService = new AreaService();
    this.estadoSelecaoService = new EstadoSelecaoService();
    this.areaProcessoService = new AreaProcessoService();
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 1 : year;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year + 1 : year;
    this.minDate = new Date();

    this.minDate.setDate(this.minDate.getDate());

    console.log(this.minDate);
    // this.minDate.setMonth(prevMonth);
    //
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    this.invalidDates = [today, invalidDate];
  },
  mounted() {
    this.processoService.getProcessos().then((data) => {
      this.processos = data;

    });
    this.areaService.getAreas().then((data) => (this.dropdownAreas = data));
    this.estadoSelecaoService.getEstadosSelecao().then((data) => {
      this.dropdownEstadosSelecao = data;
      this.dropdownEstadosSelecao = this.dropdownEstadosSelecao.filter(
        (data) => {
          return data.cod == 4 || data.cod == 0;
        }
      );
    });
    this.findTiposSelecoes();
  },
  methods: {
    findTiposSelecoes() {
      this.processoService
        .findTiposSelecoes()
        .then((data) => (this.dropdownTiposSelecao = data));
    },
    findEstadosSelecoes() {
      this.estadoSelecaoService.getEstadosSelecao().then((data) => {
        this.dropdownEstadosSelecao = data;
        this.dropdownEstadosSelecao = this.dropdownEstadosSelecao.filter(
          (data) => {
            return data.cod == 4 || data.cod == this.processo.estadoSelecao.cod;
          }
        );
      });
    },
    findEstadosSelecoesNovo() {
      this.estadoSelecaoService.getEstadosSelecao().then((data) => {
        this.processo = {};
        this.processo.estadoSelecao = data[0];
        this.dropdownEstadosSelecao = data;
        this.dropdownEstadosSelecao = this.dropdownEstadosSelecao.filter(
          (data) => {
            return data.cod == 4 || data.cod == 0;
          }
        );
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },

    openNew() {
      this.messages = [];

      this.flagEditarProcesso = true;
      this.findEstadosSelecoesNovo();


      this.processo.selecaoEstagioArea = [];
      this.areasProcesso = [];
      this.selecaoEstagioArea = {};
      this.submitted = false;
      this.processoDialog = true;
    },
    hideDialog() {
      this.processoDialog = false;
      this.submitted = false;
      this.processoService
        .getProcessos()
        .then((data) => (this.processos = data));
    },
    saveProcesso() {
      this.messages = [];
      this.submitted = true;
      if (!this.processo.selecaoEstagioArea || this.processo.selecaoEstagioArea.length <= 0) {
        this.messages = [ {severity: "error",
                          content: "Adicione uma área ao processo seletivo"}];
        return;
      }

      if (this.processo.turnoProva == null) {
        this.messages = [{
            severity: "error",
            content: `Informe o turno da prova`,
          },];
        return;
      }
      if (this.processo.horaInicioProva == null) {
        this.messages = [{
            severity: "error",
            content: `Informe a hora de início de prova`,
          },];
        return;
      }

      if (this.processo.horaFimProva == null) {
        this.messages = [{
            severity: "error",
            content: `Informe a hora de fim de prova`,
          },];
        return;
      }

      if (this.dataProva(this.processo.horaInicioProva,this.processo.horaFimProva)) {
        this.messages = [{
            severity: "error",
            content:"A hora de início da prova deve ser inferior à hora de fim",
          },];
        return;
      }

      if (this.processo.id) {
        this.updateProcesso();
      } else {
        this.createProcesso();
      }
    },
    editProcesso(processo) {
      this.viewProcesso(processo, true);
    },
    viewProcesso(processo, editar) {
      this.areasProcesso = [];
      this.messages = [];
      this.processo = { ...processo };

      this.processo = { ...this.processo, ...this.processo.prova };

      // tratando data hora prova
      this.processo.dataProva = new Date(this.processo.dataHoraFimProva);
      this.processo.dataHoraInicioProva = new Date(this.processo.dataHoraInicioProva);
      this.processo.horaInicioProva = new Date(this.processo.dataHoraInicioProva);
      this.processo.dataHoraFimProva = new Date(this.processo.dataHoraFimProva);
      this.processo.horaFimProva = new Date(this.processo.dataHoraFimProva);

      // tratando data inscrição
      this.processo.datHoraInicioInscricao = new Date(this.processo.datHoraInicioInscricao);
      this.processo.datHoraFimInscricao = new Date(this.processo.datHoraFimInscricao);

      this.processo.turnoProva = { name: this.processo.turnoProva };
      this.areasProcesso = this.processo.selecaoEstagioArea;
      this.processo.selecaoEstagioArea = this.areasProcesso;

      this.selecaoEstagioArea = {};
      this.processoAnterior = { ...this.processo };
      this.findEstadosSelecoes();
      this.processoDialog = true;
      this.flagEditarProcesso = editar;

      console.log(this.$refs.processoDialog);
    },
    confirmDeleteProcesso(processo) {
      this.processo = processo;
      this.deleteProcessoDialog = true;
    },
    deleteProcesso() {
      console.log("this.area: ", JSON.stringify(this.processo));
      this.processoService
        .delete(this.processo)
        .then(() => {
          this.processos = this.processos.filter(
            (val) => val.id !== this.processo.id
          );
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Processo excluído",
            life: 3000,
          });
          this.deleteProcessoDialog = false;
          this.processo = {};
        })
        .catch((erro) => {
          console.error(erro);
          this.messages = this.getMessagesError(erro);
          console.log("this.messages: ", this.messages);
          for (let message of this.messages) {
            this.$toast.add({
              severity: "error",
              summary: `Não foi possível excluir o processo`,
              detail: message.content,
            });
          }
          this.deleteProcessoDialog = false;
          this.processo = {};
        });
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.processos.length; i++) {
        if (this.processos[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProcessosDialog = true;
    },
    validarAtualizacaoProcesso() {
      if (!this.dataFutura(this.$formatDateTime(this.processo.datHoraInicioInscricao)) &&
            this.processo.datHoraInicioInscricao !== this.processoAnterior.datHoraInicioInscricao) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de início do período de inscrição deve ser superior ou igual à data de HOJE",
          },
        ];
        return;
      }

      if (!this.dataFutura(this.$formatDateTime(this.processo.datHoraFimInscricao)) &&
          this.processo.datHoraFimInscricao !==this.processoAnterior.datHoraFimInscricao) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de fim do período de inscrição deve ser superior ou igual à data de HOJE",
          },
        ];
        return;
      }

      if (this.dataInscricao(this.$formatDateTime(this.processo.datHoraInicioInscricao),
                        this.$formatDateTime(this.processo.datHoraFimInscricao))) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de início do período de inscrição deve ser inferior à data de fim",
          },
        ];
        return;
      }

      if ((this.processoAnterior.dataHoraInicioProva != this.processo.dataHoraInicioProva ||this.processoAnterior.dataHoraFimProva !=this.processo.dataHoraFimProva) &&
          this.processoAnterior.estadoSelecao.cod == "2") {
        this.$confirm.require({
          message:
            "O cartão de confirmação desse processo seletivo já foi disponibilizado para os candidatos. Deseja confirmar a alteração da data da prova?",
          header: "Aviso",
          acceptLabel: "Sim",
          rejectLabel: "Não",
          reject: () => {},
          accept: () => {
            this.atualizarDadosProcesso();
          },
        });
        return;
      }

      return true;
    },
    validarCriarProcesso() {
      if (!this.dataFutura(this.$formatDateTime(this.processo.datHoraInicioInscricao))) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de ínicio da inscrição do seletivo deve ser superior ou igual à data de HOJE",
          },
        ];
        return;
      }

      if (!this.dataFutura(this.$formatDateTime(this.processo.datHoraFimInscricao))) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de fim da inscrição do seletivo deve ser superior ou igual à data de HOJE",
          },
        ];
        return;
      }

      if (this.dataInscricao(this.$formatDateTime(this.processo.datHoraInicioInscricao), this.$formatDateTime(this.processo.datHoraFimInscricao))) {
        this.messages = [
          {
            severity: "error",
            content:
              "A data de início da inscrição do seletivo deve ser inferior à data de fim",
          },
        ];
        return;
      }

      return true;
    },
    createProcesso() {
      this.messages = [];

      if (!this.validarCriarProcesso()) {
        return;
      }

      this.abastecerDadosProcesso();

      this.processo.turnoProva = this.processo.turnoProva.name;
      this.processo.tipoSelecao = this.processo.tipoSelecao.cod;

      this.processoService
        .create(this.processo)
        .then((data) => {
          console.log("data: ", JSON.stringify(data));
          this.processo = data;
          this.processos.push(this.processo);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: `Processo ${this.processo.nome} criado`,
            life: 3000,
          });
          this.$store.commit("setListaProcessos", []);
          this.$store.commit('setProcessoSelecionado', this.processo);
          this.processoDialog = false;
          this.processo = {};
        })
        .catch((erro) => {
          console.error(erro);
          this.messages = this.getMessagesError(erro);
        });
    },
    updateProcesso() {
      if (!this.validarAtualizacaoProcesso()) {
        return;
      }

      this.atualizarDadosProcesso();
    },
    abastecerDadosProcesso() {
      // this.processo.dataProva.setHours(this.processo.horaInicioProva.getHours())
      // this.processo.dataProva.setMinutes(this.processo.horaInicioProva.getMinutes())
      this.processo.dataHoraInicioProva = this.$montarDataHora(this.processo.dataProva, this.processo.horaInicioProva.getHours(), this.processo.horaInicioProva.getMinutes());

      console.log(this.processo.dataHoraInicioProva);

      // this.processo.dataProva.setHours(this.processo.horaFimProva.getHours())
      // this.processo.dataProva.setMinutes(this.processo.horaFimProva.getMinutes())
      this.processo.dataHoraFimProva = this.$montarDataHora(this.processo.dataProva, this.processo.horaFimProva.getHours(), this.processo.horaFimProva.getMinutes());

      this.processo.datHoraInicioInscricao = this.$formatDate(this.processo.datHoraInicioInscricao);
      this.processo.datHoraFimInscricao = this.$formatDate(this.processo.datHoraFimInscricao);
    },
    atualizarDadosProcesso() {
      // this.processo.dataProva.setHours(this.processo.horaInicioProva.getHours())
      // this.processo.dataProva.setMinutes(this.processo.horaInicioProva.getMinutes())
      // this.processo.dataHoraInicioProva = this.$montarDataHora(this.processo.dataProva, this.processo.horaInicioProva.getHours(), this.processo.horaInicioProva.getMinutes());
      // console.log(this.processo.dataHoraInicioProva);

      // this.processo.dataProva.setHours(this.processo.horaFimProva.getHours())
      // this.processo.dataProva.setMinutes(this.processo.horaFimProva.getMinutes())

      // this.processo.dataHoraFimProva = this.$montarDataHora(this.processo.dataProva, this.processo.horaFimProva.getHours(), this.processo.horaFimProva.getMinutes());

      // this.processo.datHoraInicioInscricao = this.$formatDate(this.processo.datHoraInicioInscricao);

      // this.processo.datHoraFimInscricao = this.$formatDate(this.processo.datHoraFimInscricao);
      this.abastecerDadosProcesso();

      this.processoService.update(this.processo)
        .then((data) => {
          var index = this.findIndexById(this.processo.id);
          this.processo = data;
          this.processos.splice(index, 1, this.processo);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: `Processo ${this.processo.nome} atualizado`,
            life: 3000,
          });
          this.processoDialog = false;
          this.$store.commit("setListaProcessos", []);
          this.processo = {};
        })
        .catch((erro) => {
          console.error(erro);
          this.messages = this.getMessagesError(erro);
        });
    },
    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString().substring(0, 10);
    },
    dataFutura(value) {
      console.log(value);
      var dia = parseInt(value.substring(0, 2));
      var mes = parseInt(value.substring(3, 5)) - 1;
      var ano = parseInt(value.substring(6, 10));
      var data = new Date(ano, mes, dia);
      var dataAtual = moment().format("MM/DD/YYYY");
      dataAtual = new Date(dataAtual);

      console.log('Data Alteracao: ', data) ;
      console.log('Data atual: ', dataAtual) ;

      return data >= dataAtual;
    },
    dataProva(inicio, fim) {
      //
      //j

      return (inicio > fim);
    },
    dataInscricao(inicio, fim) {
      var dia = parseInt(inicio.substring(0, 2));
      var mes = parseInt(inicio.substring(3, 5)) - 1;
      var ano = parseInt(inicio.substring(6, 10));
      inicio = new Date(ano, mes, dia);

      dia = parseInt(fim.substring(0, 2));
      mes = parseInt(fim.substring(3, 5)) - 1;
      ano = parseInt(fim.substring(6, 10));
      fim = new Date(ano, mes, dia);

      return inicio > fim;
    },
    // AreaProcesso
    saveAreaProcesso() {
      this.messages = [];

      if (!this.selecaoEstagioArea.area) {
        this.messages = [{ severity: "error", content: `Selecione uma área!` }];
        return;
      }

      if (this.selecaoEstagioArea.vagas == null) {
        this.messages = [
          {
            severity: "error",
            content: `Informe o número de vagas ampla concorrência!`,
          },
        ];
        return;
      }

      if (this.selecaoEstagioArea.reservadas == null) {
        this.messages = [
          {
            severity: "error",
            content: `Informe o número de vagas reservadas para estudantes com deficiência!`,
          },
        ];
        return;
      }

      if (this.selecaoEstagioArea.id) {
        //Editando ...
        this.updateAreaProcesso();
      } else {
        this.createAreaProcesso();
      }
    },

    // Areas do processo
    async createAreaProcesso() {
      console.log("createAreaProcesso ...");
      if (
        (this.areaJaIncluida() && !this.flagEdit) ||
        (this.areaJaIncluida() &&
          this.flagEdit &&
          this.selecaoEstagioArea.area.id !=
            this.selecaoEstagioAreaAnterior.area.id)
      ) {
        this.messages = [
          {
            severity: "error",
            content: `Área ${this.selecaoEstagioArea.area.nome} já adicionada`,
          },
        ];
        return;
      }

      if (this.processo.id) {
        this.selecaoEstagioArea.selecaoEstagio_id = this.processo.id;
        this.selecaoEstagioArea.area_id = this.selecaoEstagioArea.area.id;

        const tmp = JSON.parse(JSON.stringify(this.selecaoEstagioArea));

        await this.areaProcessoService
          .create(tmp)
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: `Área inserida`,
              life: 3000,
            });
          })
          .catch((erro) => {
            this.messages = this.getMessagesError(erro);
          });
      }
      if (this.flagEdit) {
        console.log(this.areasProcesso);
        this.areasProcesso = this.areasProcesso.filter((e) => {
          console.log("valor de e", e);
          if (e.area.id != this.selecaoEstagioAreaAnterior.area.id) {
            console.log("entrou", this.areasProcesso);

            return e;
          }
        });

        this.flagEdit = false;
      }

      this.areasProcesso.push(this.selecaoEstagioArea);

      this.processo.selecaoEstagioArea = this.areasProcesso;
      this.selecaoEstagioArea = {};
    },

    async updateAreaProcesso() {
      if (
        (this.areaJaIncluida() && !this.flagEdit) ||
        (this.areaJaIncluida() &&
          this.flagEdit &&
          this.selecaoEstagioArea.area.id !=
            this.selecaoEstagioAreaAnterior.area.id)
      ) {
        this.messages = [
          {
            severity: "error",
            content: `Área ${this.selecaoEstagioArea.area.nome} já adicionada`,
          },
        ];
        return;
      }

      if (this.processo.id && this.selecaoEstagioArea.id) {
        const tmp = JSON.parse(JSON.stringify(this.selecaoEstagioArea));

        await this.areaProcessoService.update(tmp)
          .then(() => {
            console.log("updateAreaProcesso ...");
            let index = this.findIndexByIdArea(this.selecaoEstagioArea.area.id);
            this.areasProcesso.splice(index, 1, this.selecaoEstagioArea);
            this.processo.selecaoEstagioArea = this.areasProcesso;
            this.selecaoEstagioArea = {};

            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: `Área atualizada`,
              life: 3000,
            });
          })
          .catch((erro) => {
            this.messages = this.getMessagesError(erro);
          });
      }
    },

    CancelarAreaProcesso() {
      this.selecaoEstagioArea = {};
    },

    confirmDeleteAreaProcesso(areaProcesso) {
      this.selecaoEstagioAreaDel = areaProcesso;
      console.log(
        "selecaoEstagioArea: ",
        JSON.stringify(this.selecaoEstagioArea)
      );
      this.deleteAreaDialog = true;
    },

    async deleteAreaProcesso() {
      //a
      if (this.processo.id && this.selecaoEstagioAreaDel.id) {
        if (this.areasProcesso.length < 2) {
          this.$toast.add({
            severity: "info",
            summary: "Informação",
            detail:
              "Não é possível  excluir esta área, pois o processo precisa de pelo menos uma.",
            life: 3000,
          });
          this.selecaoEstagioArea = {};
          this.deleteAreaDialog = false;
          return;
        }
        //aa
        await this.areaProcessoService
          .delete(this.selecaoEstagioAreaDel)
          .then(() => {
            let idAreaProcesso = this.selecaoEstagioAreaDel.area.id;
            this.areasProcesso = this.areasProcesso.filter(
              (val) => val.area.id !== idAreaProcesso
            );
            this.processo.selecaoEstagioArea = this.areasProcesso;
            this.deleteAreaDialog = false;
            this.selecaoEstagioArea = {};
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: "Área excluída",
              life: 3000,
            });
          })
          .catch((erro) => {
            this.selecaoEstagioArea = {};
            this.deleteAreaDialog = false;
            this.messages = this.getMessagesError(erro);
          });
      } else {
        let idAreaProcesso = this.selecaoEstagioAreaDel.area.id;
        this.areasProcesso = this.areasProcesso.filter(
          (val) => val.area.id !== idAreaProcesso
        );
        this.processo.selecaoEstagioArea = this.areasProcesso;
        this.deleteAreaDialog = false;
        this.$toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Área excluída",
          life: 3000,
        });
      }
    },
    editAreaProcesso(areaProcesso) {
      this.messages = [];
      areaProcesso;

      const tmp = JSON.parse(JSON.stringify(areaProcesso));

      tmp.dataHoraInicioProva = new Date(tmp.dataHoraInicioProva);
      tmp.dataHoraFimProva = new Date(tmp.dataHoraFimProva);

      this.selecaoEstagioArea = tmp;

      this.selecaoEstagioAreaAnterior = areaProcesso;
      this.flagEdit = true;
    },
    findIndexByIdArea(id) {
      let index = -1;
      if (this.processo.selecaoEstagioArea) {
        for (let i = 0; i < this.processo.selecaoEstagioArea.length; i++) {
          if (this.processo.selecaoEstagioArea[i].area.id === id) {
            index = i;
            break;
          }
        }
      }
      console.log("index: ", index);
      return index;
    },
    areaJaIncluida() {
      let index = this.findIndexByIdArea(this.selecaoEstagioArea.area.id);
      console.log("index: ", index);
      return index != -1;
    },
  },
};
</script>

<style scoped lang="scss">
.processo-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-em-andamento {
    background: #256029;
    color: #ffffff;
  }

  &.status-finalizado {
    background: #808080;
    color: #ffffff;
  }
}
</style>
